import { connect, Dispatch } from "react-redux";
import React from "react";
import { SubmissionError, formValueSelector } from "redux-form";
import { RouteProps, Redirect } from "react-router";
import Snackbar, { SnackbarContent } from "material-ui/Snackbar";
import { Grid } from "material-ui";
import InfoIcon from "material-ui-icons/Info";

import ChatMessage from "./ChatMessage";
import { ReduxState, ReduxDispatch } from "../../../../ducks/reducers";
import { IChatMessage, IHandler } from "../../../../util/interfaces";

/**
 * Props provided by redux
 */
interface IChatMessagesStateProps {
    messages?: IChatMessage[];
}

/**
 * Dispatch functions provided by redux
 */
interface IChatMessagesDispatchProps {}

/**
 * Internal state of this component
 */
interface IChatMessagesState {}
interface IChatMessagesReduxProps {}

/**
 * Combined properties of he component
 */
type IChatMessagesProps = IChatMessagesStateProps &
    IChatMessagesDispatchProps &
    RouteProps;

class ChatMessages extends React.Component<
    IChatMessagesProps,
    IChatMessagesState
> {
    componentWillReceiveProps() {
        window.scrollTo(0, document.body.scrollHeight);
    }

    render() {
        const { messages } = this.props;
        return (
            <div>
                {this.props.messages &&
                    this.props.messages.map((m: IChatMessage, i: number) => {
                        return <ChatMessage key={i} message={m} />;
                    })}
            </div>
        );
    }
}
const mapStateToProps = (state: ReduxState): IChatMessagesReduxProps => {
    return {};
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IChatMessagesDispatchProps => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatMessages);



// WEBPACK FOOTER //
// ./src/views/messages/threadpage/components/ChatMessages.tsx